// @ts-ignore
import chroma from 'chroma-js';
import {memoize} from 'lodash';
import colors from 'tailwindcss/colors';

const HF_COLORS = chroma
  .cubehelix()
  .start(220)
  .rotations(-0.15)
  .gamma(0.7)
  .lightness([0.2, 0.7])
  .scale()
  .correctLightness()
  .colors(3);

function _getHfColors(numColors: number) {
  const lightnessEndPoint = numColors > 3 ? 0.8 : 0.7;
  const lightnessStartPoint = numColors > 3 ? 0.2 : 0.3;
  const rotations = numColors > 3 ? -0.35 : -0.15;
  const hfColors = chroma
    .cubehelix()
    .start(220)
    .rotations(rotations)
    .gamma(1)
    .lightness([lightnessStartPoint, lightnessEndPoint])
    .scale()
    .correctLightness()
    .colors(Math.max(numColors, 2))
    .reverse();
  return hfColors.slice(-numColors);
}

export const getHfColors = memoize(_getHfColors);

export function getRFCColors(numColors: number) {
  const lightnessEndPoint = numColors > 3 ? 0.8 : 0.7;
  const lightnessStartPoint = numColors > 3 ? 0.2 : 0.3;
  const rotations = numColors > 3 ? 0.25 : 0.15;
  const hfColors = chroma
    .cubehelix()
    .start(310)
    .rotations(rotations)
    .gamma(0.8)
    .lightness([lightnessStartPoint, lightnessEndPoint])
    .scale()
    .correctLightness()
    .colors(Math.max(numColors, 2))
    .reverse();
  return hfColors.slice(-numColors);
}

const COLORS = {
  AXIS: colors.gray[500],
  AXIS_LIGHT: colors.gray[200],
  AXIS_BG: colors.gray[50],
  OBS: colors.gray[600],
  HF_MEAN: HF_COLORS[0],
  HF_50: HF_COLORS[1],
  HF_90: HF_COLORS[2],
  HF_WARNING: colors.purple[700],
  HF_CRITICAL: colors.pink[600],
  WEATHER_1: colors.blue[600],
  WEATHER_2: colors.teal[600],
  WEATHER_3: colors.purple[600],
  WEATHER_4: colors.amber[500],
  WEATHER_5: colors.pink[600],
  SWANN_OBS: colors.sky[600],
  SNOW_RANGE: colors.blue[50],
  SNOW_LTA: colors.blue[400],
  VEG_RANGE: colors.green[50],
  VEG_LTA: colors.green[400],

  BASIN_SELECTED_FILL: colors.blue[100],
  BASIN_HOVERED_FILL: colors.gray[300],
  BASIN_DESELECTED_FILL: colors.gray[100],
  BASIN_SELECTED_STROKE: colors.blue[600],
  BASIN_DESELECTED_STROKE: colors.gray[400],

  CONTRIBUTING_AREA_STROKE: colors.blue[300],
  CONTRIBUTING_AREA_EDGE_STROKE: colors.blue[600],

  BASIN_POINT_SELECTED: colors.indigo[300],
  BASIN_POINT_HOVERED: colors.indigo[400],
  BASIN_POINT_DESELECTED: colors.indigo[500],

  BASIN_ROUTED_POINT_SELECTED: colors.indigo[300],
  BASIN_ROUTED_POINT_HOVERED: colors.indigo[400],
  BASIN_ROUTED_POINT_DESELECTED: colors.indigo[500],

  LOCATION_POINT_SELECTED: colors.green[300],
  LOCATION_POINT_HOVERED: colors.green[400],
  LOCATION_POINT_DESELECTED: colors.green[500],

  GAUGE_POINT_SELECTED: colors.amber[300],
  GAUGE_POINT_HOVERED: colors.amber[400],
  GAUGE_POINT_DESELECTED: colors.amber[500],

  FLOWLINE_MIN: colors.teal[200],
  FLOWLINE_MAX: colors.teal[500],
  FLOWLINE_BUTTON_BG: colors.teal[50],
  // Source trace colors - muted grayish variants
  SOURCE_TRACES_1: '#446a5a', // muted greenish gray
  SOURCE_TRACES_2: '#665384', // muted purplish gray
  SOURCE_TRACES_3: '#314f4f', // muted tealish gray
};

export function getColor(colorId: string): string {
  // @ts-ignore
  return COLORS[colorId] || COLORS.OBS;
}

export default COLORS;
